import "../css/SingleProduct.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import AddToCartButton from "../components/AddToCartButton";
import axios from "axios";

export default function Product() {
  const [product, setProduct] = useState(null);
  const [submitForm, setSubmitForm] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const params = useParams();

  const getProduct = async () => {
    try {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_API_URL}/products/${params.slug}`,
      });
      setProduct(response.data);
    } catch (err) {
      console.log(err.response.data.msg);
    }
  };
  const handleSubmit = async (ev) => {
    ev.preventDefault();
    setSubmitForm(true);
    setTimeout(() => {
      setSubmitForm(false);
    }, 100);
  };

  useEffect(() => getProduct(), [params]);

  const renderTooltip = (data) => (
    <Tooltip {...data}>We are sorry, this feature is not available.</Tooltip>
  );

  return (
    <div>
      <Navbar />
      <div className="single-product mt-150">
        <div className="container">
          {product && (
            <div className="row">
              <div className="col-lg-5 mb-5 single-product-img">
                <img src={process.env.REACT_APP_IMG_BASE_URL + product.image} alt={product.name} />
              </div>

              <div className="col-lg-7 single-product-content">
                <h3>{product.name}</h3>
                <p className="single-product-pricing">{product.price} US$</p>
                <p>{product.description}</p>
                <p>
                  <strong>Brand:</strong> {product.brand}
                </p>

                <p>
                  <strong>Net Weight:</strong> {product.netWeight}
                </p>
                <p>
                  <strong>Flavor:</strong> {product.flavor}
                </p>
                <div className="single-product-form">
                  <form onSubmit={handleSubmit}>
                    <input
                      type="number"
                      value={quantity}
                      onChange={(ev) =>
                        setQuantity(Math.min(Math.max(0, ev.target.value)), product.inStock)
                      }
                    />
                    <p>
                      <strong>Stock :</strong> {product.inStock}
                    </p>
                  </form>
                  <AddToCartButton
                    product={product}
                    quantityToAdd={quantity}
                    hasFormBeenSubmitted={submitForm}
                  />
                </div>
                <h4>Share:</h4>
                <ul className="product-share">
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 150, hide: 250 }}
                    overlay={renderTooltip}
                  >
                    <li>
                      <Link to="#">
                        <i className="fab fa-facebook-f"></i>
                      </Link>
                    </li>
                  </OverlayTrigger>
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 150, hide: 250 }}
                    overlay={renderTooltip}
                  >
                    <li>
                      <Link to="#">
                        <i className="fab fa-twitter"></i>
                      </Link>
                    </li>
                  </OverlayTrigger>
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 150, hide: 250 }}
                    overlay={renderTooltip}
                  >
                    <li>
                      <Link to="#">
                        <i className="fab fa-google-plus-g"></i>
                      </Link>
                    </li>
                  </OverlayTrigger>
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 150, hide: 250 }}
                    overlay={renderTooltip}
                  >
                    <li>
                      <Link to="#">
                        <i className="fab fa-linkedin"></i>
                      </Link>
                    </li>
                  </OverlayTrigger>
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}
